<template>
  <div class="x-tablelist-view">
    <el-radio-group class="flowDetail-btn" v-model="modelValue" @change="getInfo">
      <el-radio-button label="1">{{ $t('HT.ProductType.transfer') }}</el-radio-button>
      <el-radio-button label="2">{{ $t('HT.ProductType.concurrency') }}</el-radio-button>
    </el-radio-group>
    <div class="x-table-search">
      <ux-searchOption
        :layout="layout"
        :data="filter"
        @changeFilterValue="getAPIOptions"
        @changeSelectValue="getInfo"
      ></ux-searchOption>
      <div class="ux-radio">
        <span>{{ $t('HT.ProductType.Time') }}</span>
        <el-radio-group v-model="filter.dateType" @change="changeDate">
          <el-radio label="0">{{ $t('HT.flowDetail.lastHour') }}</el-radio>
          <el-radio label="1">{{ $t('HT.ProductType.lastDay') }}</el-radio>
          <el-radio label="2">{{ $t('HT.ProductType.lastWeek') }}</el-radio>
          <el-radio label="5">{{ $t('HT.ProductType.customTime') }}</el-radio>
        </el-radio-group>
        <el-date-picker
          ref="datePicker"
          v-show="isShow"
          class="data-custom"
          v-model="date"
          type="daterange"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          :start-placeholder="$t('HT.startDate')"
          :end-placeholder="$t('HT.endDate')"
          size="small"
          @change="changeDaterage"
        ></el-date-picker>
      </div>
    </div>
    <div class="chart-data">
      <div :id="el"></div>
    </div>
  </div>
</template>

<script>
import mySearchOption from '@c/mySearchOption/mySearchOption';
import echarts from '@/plugins/echarts';
export default {
  name: 'flowDetail',
  components: {
    mySearchOption
  },
  data() {
    return {
      modelValue: '1',
      layout: [
        {
          label: this.$t('HT.ProductType.selectKey'),
          type: 'select',
          key: 'appId',
          width: '320px',
          filterable: true,
          options: [],
          event: 'changeFilterValue'
        },
        {
          label: this.$t('HT.ProductType.selectApi'),
          type: 'select',
          key: 'apiId',
          width: '320px',
          options: [],
          props: { label: 'name', value: 'id' },
          event: 'changeSelectValue'
        }
      ],
      filter: {
        appId: '', // 应用key ID
        apiId: '', // APIid
        dateType: '0', // 时间时区
        beginTime: '', // 开始时间
        endTime: '' // 结束时间
      },
      date: [],
      defaultOption: {
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis'
        },
        toolbox: {
          feature: {
            dataView: {
              show: true,
              lang: ['数据视图', '关闭', '刷新']
            },
            magicType: { show: true, type: ['line', 'bar'] },
            restore: {
              show: false
            },
            myTool1: {
              show: true,
              title: this.$t('HT.reset'),
              icon: 'path://M292.072727 384.465455a25.6 25.6 0 1 1-44.311272-25.646546 303.476364 303.476364 0 0 1 566.272 151.738182 25.6 25.6 0 0 1-51.2 0A252.276364 252.276364 0 0 0 292.072727 384.465455zM207.127273 510.603636a25.6 25.6 0 1 1 51.2 0 252.276364 252.276364 0 0 0 252.276363 252.276364 251.066182 251.066182 0 0 0 190.603637-86.993455l28.718545-37.143272a25.6 25.6 0 1 1 40.494546 31.325091l-29.556364 38.167272A303.476364 303.476364 0 0 1 207.127273 510.603636z',
              onclick: () => {
                this.getInfo();
              }
            },
            saveAsImage: {}
          }
        },
        legend: {
          data: []
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: []
        },
        yAxis: {
          type: 'value',
          name: this.$t('HT.label.totalTimes'),
          axisLine: {
            show: true
          }
        },
        series: [
          {
            data: [],
            type: 'line',
            smooth: true,
            stack: 'Total'
          }
        ],
        color: '#3387FF'
      },
      $echarts: null,
      el: 'echart-wrap'
    };
  },
  computed: {
    // 判断是否显示日期选择器
    isShow() {
      return this.filter.dateType === '5';
    },
    // 判断选用哪个API
    infoAPI() {
      return this.modelValue === '2' ? this.$api.product.getQpsFlow : this.$api.product.getTotalFlow;
    }
  },
  watch: {
    defaultOption: {
      handler() {
        this.$echarts.clear();
        this.init();
      },
      deep: true
    }
  },
  mounted() {
    this.getOptions();
    this.$nextTick(() => {
      this.init();
    });
    window.addEventListener('resize', this.handleResize);
    this.$once('hook:beforeDestroy', this.handleResize);
  },
  methods: {
    getOptions() {
      let param = {
        page: 1,
        size: 100
      };
      this.$api.apply.getList(param).then((res) => {
        let itemList = [];
        for (let item of res.data) {
          itemList.push({ label: item.name + `(${item.app_key})`, value: item.id });
        }
        if (res.data.length > 0) {
          this.filter.appId = res.data[0].id;
        }
        this.layout[0].options = itemList;
        this.getAPIOptions(this.filter.appId);
      });
    },
    getInfo() {
      this.changeYTitle();
      console.log('this.modelValue', this.modelValue, typeof this.modelValue);
      let key =this.modelValue === '2'?'qps':'count';
      this.infoAPI(this.filter).then((res) => {
        const xAxis = [];
        const yAxis = [];
        for (let item of res.data[0].api_analyse_vodetail_list) {
          xAxis.push(item.data_time);
          yAxis.push(item[key]);
        }
        this.defaultOption.xAxis.data = xAxis;
        this.defaultOption.series[0].data = yAxis;
      });
    },
    changeYTitle() {
      this.defaultOption.yAxis.name = this.modelValue === '1' ? this.$t('HT.label.totalTimes') : 'QPS';
    },
    changeDate() {
      if (this.filter.dateType === '5') {
        return null;
      }
      this.getInfo();
    },
    // 获取接口配置
    getAPIOptions(val) {
      val &&
        this.$api.product.getApi(val).then((res) => {
          this.layout[1].options = res.data;
          console.log(res.data.length, res.data.length);
          if (res.data.length > 0) {
            this.filter.apiId = res.data[0].id;
          } else {
            this.filter.apiId = '';
          }
          if (this.filter.apiId) {
            this.getInfo();
          } else {
            this.$uxMessage.error(this.$t('HT.product.NoAPI'));
          }
        });
    },
    changeDaterage(date) {
      if (date?.length) {
        const [startTime, endTime] = date || [];
        console.log('date', startTime, endTime);
        this.filter.beginTime = startTime + ' 00:00:00';
        this.filter.endTime = endTime + ' 00:00:00';
      }
      this.getInfo();
    },
    init() {
      if (!this.$echarts) {
        this.$echarts = echarts.init(document.getElementById(this.el));
        console.log('$init', this.$echarts);
      }
      this.$echarts.setOption(this.defaultOption);
    },
    handleResize() {
      this.$echarts.resize();
    },
    changeType() {
      this.form.date = [];
    },
    reset() {
      this.filter.dateType = '1';
      this.filter.date = [];
      this.filter.beginTime = '';
      this.filter.endTime = '';
    }
  }
};
</script>

<style scoped>
.flowDetail-btn {
  margin-top: 16px;
}
#echart-wrap {
  width: 100%;
  height: 400px;
}
.data-custom {
  margin-left: 16px;
}
.ux-radio {
  height: 40px;
  display: flex;
  align-items: center;
  .el-radio-group {
    margin-left: 16px;
  }
}
.x-table-search {
  margin-left: 40px
}
::v-deep .ux-select {
  margin-left: 8px;
}
</style>
